import React, {
    createContext,
    Dispatch,
    SetStateAction,
    useMemo,
    useState,
} from "react";
import { PartyModel } from "../types";

interface PartiesContextData {
    myPartiesInfo: PartyModel[];
    alsoGoingOutGroups: PartyModel[];
    selectedParty: PartyModel | null;

    setMyPartiesInfoContextData: Dispatch<SetStateAction<PartyModel[]>>;
    setAlsoGoingOutGroupsContextData: Dispatch<SetStateAction<PartyModel[]>>;
    setSelectedPartyContextData: Dispatch<SetStateAction<PartyModel | null>>;
}

export const PartiesContext = createContext<PartiesContextData>({
    myPartiesInfo: [],
    alsoGoingOutGroups: [],
    selectedParty: null,

    setMyPartiesInfoContextData: () => { },
    setAlsoGoingOutGroupsContextData: () => { },
    setSelectedPartyContextData: () => { },
});

export const PartiesProvider: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {

    const [myPartiesInfo, setMyPartiesInfoContextData] = useState<PartyModel[]>([]);
    const [alsoGoingOutGroups, setAlsoGoingOutGroupsContextData] = useState<PartyModel[]>([]);
    const [selectedParty, setSelectedPartyContextData] = useState<PartyModel | null>(null);

    const value = useMemo(() => ({
        myPartiesInfo,
        alsoGoingOutGroups,
        selectedParty,
        setMyPartiesInfoContextData,
        setAlsoGoingOutGroupsContextData,
        setSelectedPartyContextData,
    }), [myPartiesInfo, alsoGoingOutGroups, selectedParty]);

    return (
        <PartiesContext.Provider value={value}>
            {children}
        </PartiesContext.Provider>
    );
};
